import z from "zod";
import createSchemaUtils from "../helpers/createSchemaUtils";

export const SafeNameSchema = z.union([
    z.string().regex(/^[a-zA-Z_][a-zA-Z0-9_$]*$/, {
        message: "Name must start with a letter or underscore and can only contain letters, numbers, or underscores."
    }).nonempty(),
    z.literal("$$Id"), // Allow $$Id as a valid SafeName
    z.literal("$$DisplayName"), // Allow $$DisplayName as a valid SafeName
    z.literal("$$Entity"), // Allow $$Entity as a valid SafeName
]);
/**
 * A string that is safe to use as an identifier (e.g., variable name, property name).
 * Name must start with a letter or underscore and can only contain letters, numbers, or underscores.
 * USAGE:
 * ```typescript
 * const name: SafeName = "valid_name_123";
 * // The following would throw a validation error:
 * // const invalidName: SafeName = "123-invalid-name"; // Error: Name must start with a letter or underscore...
 * ```
 */
export type SafeName = z.infer<typeof SafeNameSchema>;
export const SafeName = createSchemaUtils(SafeNameSchema);


// create zod equivalent for QueryRequestOptions
export const QueryRequestOptionsSchema = z.object({
    accessToken: z.string().optional(),
});
export type QueryRequestOptions<TExtend = {}> = z.infer<typeof QueryRequestOptionsSchema> & TExtend;
export const QueryRequestOptions = createSchemaUtils(QueryRequestOptionsSchema, {
    test() { }
});

/**
 * A string that can also be null or undefined.
 * USAGE:
 * ```typescript
 * const name1: NString = "Hello, World!";
 * const name2: NString = null;
 * const name3: NString = undefined;
 * ```
 */
export type NString = string | null | undefined;